import widgetInit from '../widgetCore';
import Carousel from '../widgetCore/Carousel';
import { fetcher } from '../widgetCore/helpers';
import Statistic from './Statistic';
import ParentReceiver from './Receiver';
import ParentSender from './Sender';

const statistic = new Statistic({
  fetcher,
});

const parentReceiver = new ParentReceiver();
const parentSender = new ParentSender();

const mainSliderContainer = document.getElementById('slider-tiles-container');

const carousel = new Carousel({
  mainContainer: mainSliderContainer,
});

widgetInit({
  statistic,
  parentReceiver,
  parentSender,
  mainSliderContainer,
  carousel,
}).then(() => {
  carousel.initAutoRotate();
});
